// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DqZgBsvdDxZXiRak6K33 {
	position: relative;
}

.DqZgBsvdDxZXiRak6K33.uKfII_Dkm3PWtJsvzCi4 {
		pointer-events: none;
	}

.DqZgBsvdDxZXiRak6K33.uKfII_Dkm3PWtJsvzCi4 > .VLUPcFVdT9Qe3yB7P5B1 {
			padding-right: 12px;
		}

.VLUPcFVdT9Qe3yB7P5B1 {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	width: 100%;
	height: 40px;
	padding: 0 8px 0 12px;
	border-radius: 8px;
	border: 0;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;
	background-color: var(--black);
}

.VLUPcFVdT9Qe3yB7P5B1:disabled {
		cursor: default;
	}

.jKmlcTGCxcGggQevM6HH {
	z-index: 100;
	min-width: var(--radix-select-trigger-width);
	padding: 8px 12px;
	border-radius: 8px;
	background-color: var(--black);
}

.bmGQHlbKquWZXrL2khvZ {
	font-weight: 400;
	display: flex;
	align-items: center;
	min-height: 40px;
	line-height: 16px;
	cursor: pointer;
	outline: none;
}

.bmGQHlbKquWZXrL2khvZ[data-disabled] {
		cursor: default;
		opacity: 0.5;
	}
`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.pcss"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AASnB;;AAPC;EACC,oBAAoB;CAKrB;;AAHC;GACC,mBAAmB;EACpB;;AAIF;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,cAAc;CACd,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,8BAA8B;AAK/B;;AAHC;EACC,eAAe;CAChB;;AAGD;CACC,YAAY;CACZ,4CAA4C;CAC5C,iBAAiB;CACjB,kBAAkB;CAClB,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,aAAa;AAMd;;AAJC;EACC,eAAe;EACf,YAAY;CACb","sourcesContent":[".root {\n\tposition: relative;\n\n\t&.disabled {\n\t\tpointer-events: none;\n\n\t\t& > .select {\n\t\t\tpadding-right: 12px;\n\t\t}\n\t}\n}\n\n.select {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 8px;\n\twidth: 100%;\n\theight: 40px;\n\tpadding: 0 8px 0 12px;\n\tborder-radius: 8px;\n\tborder: 0;\n\tcolor: inherit;\n\tfont: inherit;\n\ttext-align: left;\n\tcursor: pointer;\n\tbackground-color: var(--black);\n\n\t&:disabled {\n\t\tcursor: default;\n\t}\n}\n\n.options {\n\tz-index: 100;\n\tmin-width: var(--radix-select-trigger-width);\n\tpadding: 8px 12px;\n\tborder-radius: 8px;\n\tbackground-color: var(--black);\n}\n\n.optionItem {\n\tfont-weight: 400;\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: 40px;\n\tline-height: 16px;\n\tcursor: pointer;\n\toutline: none;\n\n\t&[data-disabled] {\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DqZgBsvdDxZXiRak6K33`,
	"disabled": `uKfII_Dkm3PWtJsvzCi4`,
	"select": `VLUPcFVdT9Qe3yB7P5B1`,
	"options": `jKmlcTGCxcGggQevM6HH`,
	"optionItem": `bmGQHlbKquWZXrL2khvZ`
};
export default ___CSS_LOADER_EXPORT___;
